module.exports = __webpack_public_path__ + "img/quan.58b1683d.svg";